import { Component, OnInit } from '@angular/core';
import { TableQuotationsComparativeService, QuotationColumn } from '../../../services/table-quotations-comparative.service';
import { ExternalRequestEntry } from '../../../models/requisitions/interfaces/external-request-entry';
import { EnumService } from '../../../services/enum.service';
import { EnumValues } from '@card-software/library';

@Component({
  selector: 'app-quote-comparative-table',
  templateUrl: './quote-comparative-table.component.html',
  styleUrl: './quote-comparative-table.component.scss',
})
export class QuoteComparativeTableComponent implements OnInit {
  uomEnum: EnumValues = {};

  constructor(
    public tableService: TableQuotationsComparativeService,
    private enumService: EnumService,
  ) {
    this.uomEnum = this.enumService.getEnum('UnitOfMeasurement', 'itemEnums').values;
  }

  ngOnInit(): void {
    // console.log(this.tableService.getComparativeQuotations());
    console.log(this.tableService.quotationsColumns());
  }

  getUomLabel(uomValue: number): string {
    return '';
  }

  trackByItemCode(index: number, item: ExternalRequestEntry): string {
    return item.itemCode;
  }

  trackByQuotationId(index: number, column: QuotationColumn): string {
    return column.id;
  }

  onCreatePurchaseOrder(quotationColumn: QuotationColumn): void {
    if (!quotationColumn.isProviderSaved) {
      console.log('Provider must be saved before creating purchase order');
      return;
    }
    console.log('Creating purchase order for:', quotationColumn.providerName);
    // TODO: Implement purchase order creation logic
  }
}
